module.exports = __webpack_public_path__ + "img/reports-icon-green.72353234.svg";